<div class="container-space-between">
  <app-page-title
    [title]="translations.title"
    [backText]="translations.titleBackText"
    [goBackRoute]="isPreviousHistoryAdmin ? routingEnum.ADMIN : undefined"
  ></app-page-title>
  <app-button-group [visible]="hasEntitiesWriteAccess">
    <app-more-actions-buttons
      (clickLabel)="onAdd()"
      [label]="translations.addNewLabel"
      labelIcon="Add"
    >
      <app-dropdown-menu-item (pressed)="onOpenBulkAddSlideOver()">
        <mat-icon>library_add</mat-icon>
        <ng-container i18n="@@shared.bulkaddproducts">Bulk add products</ng-container>
      </app-dropdown-menu-item>
    </app-more-actions-buttons>
  </app-button-group>
</div>

<app-products-table
  [recordState]="recordStateEnum.ACTIVE"
  [isSaveTableState]="true"
  [isFixedBottomPaginator]="true"
  [areButtonsEnabled]="hasEntitiesWriteAccess"
  [isBatchActionsEnabled]="hasEntitiesWriteAccess"
  [isCustomFieldsEnabled]="true"
></app-products-table>
